import { FONT_BASE } from '../../constants/AppFonts';
import { ButtonComposited } from '../../display/ui/ButtonComposited';

export class EndScreen extends Phaser.GameObjects.Container {
  constructor(scene, opts) {
    super(scene);
    scene.add.existing(this);
    this.scene.game.soundController.playMusic('music');
    this.scene.game.soundController.stopAllSFX();

    if (opts.win) {
      this.add([
        scene.add.image(840, 50, 'shared_ui', 'level_win_panel').setOrigin(0.5, 0),
        scene.add.image(840, 61, 'shared_ui', 'stars_0' + opts.stars).setOrigin(0.5, 0),
        opts.gameid == 'EcoExpert'
          ? scene.add.image(588, 295, `challenge_EcoExpert`).setAngle(-2)
          : scene.add.image(588, 295, 'shared_ui', `challenge_${opts.gameid}`).setAngle(-2),
        this._createText(190, scene.game.copy.get('title_remember'), 28, {
          x: 800,
          align: 'left',
        }).setOrigin(0),
        this._createText(226, scene.game.copy.get(`${opts.gameid}_win_copy`), 22, {
          font: FONT_BASE.COPY,
          wordWrap: 415,
          x: 800,
          align: 'left',
        }).setOrigin(0),
      ]);

      if (scene.game.allowExternalURL) {
        const btnChallenge = new ButtonComposited(scene, {
          x: 0,
          y: 525,
          icon: 'btn_challenge_icon',
          copyid: 'label_takethechallenge',
          buttonType: 'secondary',
          colour: '#00a6e9', // 00a8ef
        });
        btnChallenge.x = 1270 - btnChallenge.displayWidth * 0.5;
        btnChallenge.on('pointerdown', this.handleVisitChallenges, this);
        this.add([
          this._createText(480, scene.game.copy.get('title_findoutmore'), 22, {
            font: FONT_BASE.COPY,
            x: 415,
            align: 'left',
            color: '#ffffff',
          }).setOrigin(0),
          this._createText(510, scene.game.copy.get('title_climatechampions').split('<br/>'), 22, {
            x: 415,
            align: 'left',
            color: '#ffffff',
            wordWrap: 300,
          }).setOrigin(0),
          btnChallenge,
        ]);
      }
    } else {
      this.add([
        scene.add.image(840, 50, 'shared_ui', 'level_fail_panel').setOrigin(0.5, 0),
        scene.add.image(840, 61, 'shared_ui', 'stars_0' + opts.stars).setOrigin(0.5, 0),
        this._createText(195, scene.game.copy.get('title_levelfail'), 52),
        this._createText(250, scene.game.copy.get(`${opts.gameid}_fail_title`), 28),
        this._createText(320, scene.game.copy.get('title_hint'), 28, {
          colour: '#e6007e',
        }),
        this._createText(360, scene.game.copy.get(`${opts.gameid}_fail_hint`), 28, {
          font: FONT_BASE.COPY,
        }),
      ]);
    }

    const btn = new ButtonComposited(scene, {
      x: 840,
      y: 650,
      icon: opts.win ? 'btn_continue_icon' : 'btn_restart_icon',
      copyid: opts.win ? 'label_continue' : 'label_restart',
      buttonType: 'primary',
      colour: '#ff007f', // 00a8ef
    });
    btn.on('pointerup', opts.win ? this.onContinue : this.onRestart, this);
    this.add(btn);
  }

  _createText(
    y,
    copy,
    size,
    { x = 840, color = '#000000', font = FONT_BASE.TITLE, wordWrap = 760, align = 'center' } = {}
  ) {
    return this.scene.add
      .text(x, y, copy, {
        font: `${size}px ${font}`,
        color,
        align,
        wordWrap: { width: wordWrap, useAdvancedWrap: true },
      })
      .setOrigin(0.5, 0);
  }

  handleVisitChallenges() {
    window.open(this.scene.game.copy.get('url_climate_champions'), '_blank');
    // window.location.assign(this.scene.game.copy.get('url_climate_champions'));
  }

  onRestart() {
    this.emit('RESTART');
  }

  onContinue() {
    this.emit('CONTINUE');
  }
}
